<template>
    <div class="main_center" v-loading.fullscreen.lock="loading">
<!--        <div class="top-content busWinessLeft">-->
<!--            <div class="left-navbar">-->
<!--                <el-button @click="back()" size="small">返回</el-button>-->
<!--                <el-button type="primary" plain size="small" @click="saveFormData" >保存</el-button>-->
<!--            </div>-->
<!--        </div>-->
        <div class="right-content clearfix busWinessRight">
            <formInformation v-if="true" ref="formInformation" />
            <viewInformation v-else ref="viewInformation" />
        </div>

    </div>
</template>

<script>
    import formInformation from './components/formInformation'
    import viewInformation from './components/viewInformation'
    export default {
    components:{
        formInformation,
        viewInformation
    },
    data(){
        return{
            loading:false,
        }
    },
    mounted(){
    },
    methods:{
        back(){// 返回
            tabsCloseCurrentHandle();
        },
        saveFormData(){
           this.$refs.formInformation.save()
        },
    }
}
</script>

<style lang="scss" scoped>
    .right-content{
        
    }
    .left-content.busWinessLeft{
        .left-navbar{
            width:150px;
            border:none;
        }
    }
    
    
</style>
